import React from 'react';

import { Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

import ChevronTopIcon from '~/assets/icons/ChevronTopIcon';
import { useDiscoverContext } from '~/context/DiscoverContext';
import { SMALL_MARGIN_PX } from '~/theme';

interface CategoryNavigationProps {
  to: string;
  children: string;
}

const CategoryNavigationLink: React.FC<CategoryNavigationProps> = ({ to, children, ...rest }) => {
  const theme = useTheme();
  const { setOpenFiltersPanel } = useDiscoverContext();

  return (
    <StyledLink
      data-testid={rest['data-testid']}
      to={to}
      onClick={() => setOpenFiltersPanel(false)}
    >
      <ChevronIcon color={theme.palette.common.white} />
      <Text>{children}</Text>
    </StyledLink>
  );
};

export default CategoryNavigationLink;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;
const ChevronIcon = styled(ChevronTopIcon)`
  width: 16px;
  height: 16px;
  transform: rotate(270deg);
  margin-right: ${SMALL_MARGIN_PX};
`;
const Text = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray};
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0;
`;
